import React from 'react';
import { Badge, Text } from '@wix/design-system';
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { useIsMobile } from '../../hooks/useIsMobile';
import s from './MatchLabelBadge.css';
const labelTranslationKey = {
  [RecommendationLabel.EXACT_MATCH]: 'domain_search_suite.domain_suggestions.badge.exact_match',
  [RecommendationLabel.BEST_MATCH]: 'domain_search_suite.domain_suggestions.badge.best_match',
  [RecommendationLabel.GREAT_ALTERNATIVE]: 'domain_search_suite.domain_suggestions.badge.great_alternative'
};
export const hasMatchLabel = label => label !== undefined && label !== RecommendationLabel.UNKNOWN_LABEL && Boolean(labelTranslationKey[label]);
export const MatchLabelBadge = _ref => {
  let {
    label,
    optimized = false,
    primary = false
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const size = isMobile ? 'tiny' : 'small';
  const key = label === 'RECOMMENDED' ? 'domains_search_suite.anon_storefront_results.optimizations.container.double_taken.badge' : labelTranslationKey[label];
  if (!key) {
    return null;
  }
  const className = optimized && !primary ? s.MatchBadgeOptimizedAlt : s.MatchBadge;
  return /*#__PURE__*/React.createElement(Badge, {
    skin: "premium",
    size: size,
    uppercase: false,
    className: className
  }, /*#__PURE__*/React.createElement(Text, {
    size: size,
    weight: "normal",
    light: true
  }, t(key)));
};
//# sourceMappingURL=MatchLabelBadge.js.map